module.exports = { raw: '8.8.0' };



//////////////////
// WEBPACK FOOTER
// /Users/Nathan/Desktop/Computing Sciences/dissertation/pairgo/pairgo-ng/~/auth0-js/src/version.js
// module id = ../../../../auth0-js/src/version.js
// module chunks = 4